import {
  customInstance
} from "../../chunk-Y7KXQJM2.mjs";

// generated/api/index.ts
var getRebuildAPI = () => {
  const storageControllerGetFile = (options) => {
    return customInstance({ url: `/rest/files/*`, method: "GET" }, options);
  };
  const storageControllerUploadValueAddFile = (storageControllerUploadValueAddFileBody, options) => {
    const formData = new FormData();
    if (storageControllerUploadValueAddFileBody?.files !== void 0) {
      storageControllerUploadValueAddFileBody?.files.forEach((value) => formData.append(`files`, value));
    }
    if (storageControllerUploadValueAddFileBody?.organizationId !== void 0) {
      formData.append(`organizationId`, storageControllerUploadValueAddFileBody.organizationId);
    }
    if (storageControllerUploadValueAddFileBody?.estimateId !== void 0) {
      formData.append(`estimateId`, storageControllerUploadValueAddFileBody.estimateId);
    }
    return customInstance({ url: `/rest/files/upload/value-add`, method: "POST", data: formData }, options);
  };
  const storageControllerDeletePhotos = (deleteResponsiveNotePhotosBody, options) => {
    return customInstance(
      {
        url: `/rest/files/photos`,
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        data: deleteResponsiveNotePhotosBody,
        responseType: "blob"
      },
      options
    );
  };
  const storageControllerUploadFile = (storageControllerUploadFileBody, options) => {
    const formData = new FormData();
    if (storageControllerUploadFileBody?.files !== void 0) {
      storageControllerUploadFileBody?.files.forEach((value) => formData.append(`files`, value));
    }
    if (storageControllerUploadFileBody?.destination !== void 0) {
      formData.append(`destination`, storageControllerUploadFileBody.destination);
    }
    if (storageControllerUploadFileBody?.estimateId !== void 0) {
      formData.append(`estimateId`, storageControllerUploadFileBody.estimateId);
    }
    if (storageControllerUploadFileBody?.tpa !== void 0) {
      formData.append(`tpa`, storageControllerUploadFileBody.tpa);
    }
    if (storageControllerUploadFileBody?.carrier !== void 0) {
      formData.append(`carrier`, storageControllerUploadFileBody.carrier);
    }
    if (storageControllerUploadFileBody?.uploadId !== void 0) {
      formData.append(`uploadId`, storageControllerUploadFileBody.uploadId);
    }
    if (storageControllerUploadFileBody?.postUploadCommand !== void 0) {
      formData.append(`postUploadCommand`, storageControllerUploadFileBody.postUploadCommand);
    }
    return customInstance({ url: `/rest/files/upload`, method: "POST", data: formData }, options);
  };
  const estimatesControllerGetEstimateMetadata = (params, options) => {
    return customInstance({ url: `/rest/estimates/get-estimates-metadata`, method: "GET", params }, options);
  };
  const estimatesControllerGetFinalEstimates = (params, options) => {
    return customInstance({ url: `/rest/estimates/get_final_estimates`, method: "GET", params }, options);
  };
  const estimatesControllerGetResponsiveNotePhotos = (params, options) => {
    return customInstance(
      { url: `/rest/estimates/getResponsiveNotePhotos`, method: "GET", params },
      options
    );
  };
  const estimatesControllerGetResponsiveNotePhotoLabels = (params, options) => {
    return customInstance(
      { url: `/rest/estimates/getResponsiveNotePhotoLabels`, method: "GET", params },
      options
    );
  };
  const estimatesControllerReassignResponsiveNotePhotos = (estimateId, reassignResponsiveNotePhotosBody, params, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/reassignResponsiveNotePhotos`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: reassignResponsiveNotePhotosBody,
        params
      },
      options
    );
  };
  const estimatesControllerApplyResponsiveNotePhotoLabels = (estimateId, applyResponsiveNotePhotoLabelsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/applyResponsiveNotePhotoLabels`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: applyResponsiveNotePhotoLabelsBody
      },
      options
    );
  };
  const estimatesControllerGetXactimateMappingForLineItem = (params, options) => {
    return customInstance({ url: `/rest/estimates/getXactimateMappingForLineItem`, method: "GET", params }, options);
  };
  const estimatesControllerGetXactimateMapping = (params, options) => {
    return customInstance({ url: `/rest/estimates/getXactimateMapping`, method: "GET", params }, options);
  };
  const estimatesControllerGetXactimateMappingByTemplate = (params, options) => {
    return customInstance(
      { url: `/rest/estimates/getXactimateMappingByTemplate`, method: "GET", params },
      options
    );
  };
  const estimatesControllerDuplicateEstimate = (params, options) => {
    return customInstance({ url: `/rest/estimates/duplicate_estimate`, method: "GET", params }, options);
  };
  const estimatesControllerGetEstimate = (params, options) => {
    return customInstance({ url: `/rest/estimates/get_estimate`, method: "GET", params }, options);
  };
  const estimatesControllerCreateNewEstimateRequest = (params, options) => {
    return customInstance({ url: `/rest/estimates/createNewEstimateRequest`, method: "GET", params }, options);
  };
  const estimatesControllerGetEstimateRequests = (options) => {
    return customInstance({ url: `/rest/estimates/getEstimateRequests`, method: "GET" }, options);
  };
  const estimatesControllerMergePages = (estimatesControllerMergePagesBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/mergePages`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerMergePagesBody
      },
      options
    );
  };
  const estimatesControllerUpdateEstimaticsEstimate = (estimatesControllerUpdateEstimaticsEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/updateEstimaticsEstimate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerUpdateEstimaticsEstimateBody
      },
      options
    );
  };
  const estimatesControllerUpdateEstimateMitigationDetails = (updateEstimateMitigationDetailsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/updateEstimateMitigationDetails`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: updateEstimateMitigationDetailsBody
      },
      options
    );
  };
  const estimatesControllerArchive = (archiveEstimateBody, options) => {
    return customInstance(
      { url: `/rest/estimates/archive`, method: "POST", headers: { "Content-Type": "application/json" }, data: archiveEstimateBody },
      options
    );
  };
  const estimatesControllerAddNote = (estimateId, addNoteBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/documentation`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: addNoteBody
      },
      options
    );
  };
  const estimatesControllerCreateEstimaticsEstimate = (estimatesControllerCreateEstimaticsEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/createEstimaticsEstimate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerCreateEstimaticsEstimateBody
      },
      options
    );
  };
  const estimatesControllerAddEstimateRequestFiles = (estimatesControllerAddEstimateRequestFilesBody, options) => {
    const formData = new FormData();
    if (estimatesControllerAddEstimateRequestFilesBody?.files !== void 0) {
      estimatesControllerAddEstimateRequestFilesBody?.files.forEach((value) => formData.append(`files`, value));
    }
    if (estimatesControllerAddEstimateRequestFilesBody?.requestId !== void 0) {
      formData.append(`requestId`, estimatesControllerAddEstimateRequestFilesBody.requestId);
    }
    return customInstance({ url: `/rest/estimates/addEstimateRequestFiles`, method: "POST", data: formData }, options);
  };
  const estimatesControllerRestoreDocument = (estimatesControllerRestoreDocumentBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/restoreDocument`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerRestoreDocumentBody
      },
      options
    );
  };
  const estimatesControllerApplyTpaRules = (estimatesControllerApplyTpaRulesBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/applyTPARules`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerApplyTpaRulesBody
      },
      options
    );
  };
  const estimatesControllerRevertAppliedTpaRules = (estimatesControllerRevertAppliedTpaRulesBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/revertTPARules`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerRevertAppliedTpaRulesBody
      },
      options
    );
  };
  const estimatesControllerSetXatimateMappings = (estimatesControllerSetXatimateMappingsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/setXatimateMappings`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerSetXatimateMappingsBody
      },
      options
    );
  };
  const estimatesControllerSetMappings = (estimatesControllerSetMappingsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/setMappings`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerSetMappingsBody
      },
      options
    );
  };
  const estimatesControllerGetUserXactimateMapping = (options) => {
    return customInstance({ url: `/rest/estimates/getUserXactimateMapping`, method: "GET" }, options);
  };
  const estimatesControllerAddUserXactimateMapping = (estimatesControllerAddUserXactimateMappingBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/addUserXactimateMapping`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerAddUserXactimateMappingBody
      },
      options
    );
  };
  const estimatesControllerGetLineItemElements = (params, options) => {
    return customInstance({ url: `/rest/estimates/getLineItemElements`, method: "GET", params }, options);
  };
  const estimatesControllerGetLineItemOrderIndex = (params, options) => {
    return customInstance({ url: `/rest/estimates/getLineItemOrderIndex`, method: "GET", params }, options);
  };
  const estimatesControllerDeleteAll = (options) => {
    return customInstance({ url: `/rest/estimates/deleteAll`, method: "GET" }, options);
  };
  const estimatesControllerGenerateLineItemFromInput = (params, options) => {
    return customInstance({ url: `/rest/estimates/generateLineItemFromInput`, method: "GET", params }, options);
  };
  const estimatesControllerCopylineItemsForQa = (params, options) => {
    return customInstance({ url: `/rest/estimates/copylineItemsForQA`, method: "GET", params }, options);
  };
  const estimatesControllerValidatePdfExport = (params, options) => {
    return customInstance({ url: `/rest/estimates/validatePDFExport`, method: "GET", params }, options);
  };
  const estimatesControllerValidateXactimateExport = (params, options) => {
    return customInstance({ url: `/rest/estimates/validateXactimateExport`, method: "GET", params }, options);
  };
  const estimatesControllerExportTo1Pager = (estimatesControllerExportTo1PagerBody, params, options) => {
    return customInstance(
      {
        url: `/rest/estimates/exportTo1Pager`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerExportTo1PagerBody,
        params
      },
      options
    );
  };
  const estimatesControllerExportPhotoReport = (estimateId, exportPhotoReportBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/exportPhotoReport`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: exportPhotoReportBody
      },
      options
    );
  };
  const estimatesControllerGetPhotoReportLetterhead = (estimateId, options) => {
    return customInstance(
      { url: `/rest/estimates/${estimateId}/photoReportLetterhead`, method: "GET" },
      options
    );
  };
  const estimatesControllerDownloadScopeNotes = (estimateId, estimatesControllerDownloadScopeNotesBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/downloadScopeNotes`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerDownloadScopeNotesBody
      },
      options
    );
  };
  const estimatesControllerExportToXactimate = (estimatesControllerExportToXactimateBody, params, options) => {
    return customInstance(
      {
        url: `/rest/estimates/exportToXactimate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerExportToXactimateBody,
        params
      },
      options
    );
  };
  const estimatesControllerStartXactimatePhotoUpload = (params, options) => {
    return customInstance({ url: `/rest/estimates/startXactimatePhotoUpload`, method: "POST", params }, options);
  };
  const estimatesControllerRejectFixedMapping = (estimatesControllerRejectFixedMappingBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/rejectFixedMapping`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerRejectFixedMappingBody
      },
      options
    );
  };
  const estimatesControllerGetFixedMapping = (options) => {
    return customInstance({ url: `/rest/estimates/getFixedMapping`, method: "GET" }, options);
  };
  const estimatesControllerGetLineItemById = (params, options) => {
    return customInstance({ url: `/rest/estimates/getLineItemById`, method: "GET", params }, options);
  };
  const estimatesControllerSearchLineItems = (params, options) => {
    return customInstance({ url: `/rest/estimates/searchLineItems`, method: "GET", params }, options);
  };
  const estimatesControllerSearchLineItemsV2 = (params, options) => {
    return customInstance({ url: `/rest/estimates/v2/searchLineItems`, method: "GET", params }, options);
  };
  const estimatesControllerUpdateOrCreateLineItem = (estimatesControllerUpdateOrCreateLineItemBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/updateOrCreateLineItem`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerUpdateOrCreateLineItemBody
      },
      options
    );
  };
  const estimatesControllerBatchUpdateOrCreateLineItems = (estimatesControllerBatchUpdateOrCreateLineItemsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/batchUpdateOrCreateLineItems`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerBatchUpdateOrCreateLineItemsBody
      },
      options
    );
  };
  const estimatesControllerUpdateOrCreateFinalEstimateMetadata = (estimatesControllerUpdateOrCreateFinalEstimateMetadataBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/updateOrCreateFinalEstimateMetadata`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerUpdateOrCreateFinalEstimateMetadataBody
      },
      options
    );
  };
  const estimatesControllerPasteLineItems = (estimatesControllerPasteLineItemsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/pasteLineItems`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerPasteLineItemsBody
      },
      options
    );
  };
  const estimatesControllerValidateDocusketch = (estimatesControllerValidateDocusketchBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/validateDocusketch`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerValidateDocusketchBody
      },
      options
    );
  };
  const estimatesControllerValidateUploadedPdfFormat = (estimatesControllerValidateUploadedPdfFormatBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/validateUploadedPdfFormat`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerValidateUploadedPdfFormatBody
      },
      options
    );
  };
  const estimatesControllerTranscriptToScopeNotes = (estimatesControllerTranscriptToScopeNotesBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/transcriptToScopeNotes`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerTranscriptToScopeNotesBody
      },
      options
    );
  };
  const estimatesControllerGetZipTaxRate = (estimatesControllerGetZipTaxRateBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/zipTaxRate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerGetZipTaxRateBody
      },
      options
    );
  };
  const estimatesControllerGetPdfPreviewData = (estimatesControllerGetPdfPreviewDataBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/pdfPreviewData`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerGetPdfPreviewDataBody
      },
      options
    );
  };
  const estimatesControllerCreateRoom = (estimatesControllerCreateRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/createRoom`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerCreateRoomBody
      },
      options
    );
  };
  const estimatesControllerArchiveRoom = (estimatesControllerArchiveRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/archiveRoom`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimatesControllerArchiveRoomBody
      },
      options
    );
  };
  const estimateChatControllerListChats = (estimateId, params, options) => {
    return customInstance({ url: `/rest/estimates/${estimateId}/chats`, method: "GET", params }, options);
  };
  const estimateChatControllerGetMessages = (estimateId, chatId, params, options) => {
    return customInstance(
      { url: `/rest/estimates/${estimateId}/chats/${chatId}/messages`, method: "GET", params },
      options
    );
  };
  const estimateChatControllerPostMessage = (estimateId, chatId, estimateChatPostMessageBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/chats/${chatId}/messages`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: estimateChatPostMessageBody
      },
      options
    );
  };
  const estimateChatControllerUpdateChat = (estimateId, chatId, estimateChatUpdateBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/chats/${chatId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: estimateChatUpdateBody
      },
      options
    );
  };
  const estimateChatControllerAcceptProposals = (estimateId, chatId, proposalIdsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/chats/${chatId}/proposals/accept`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: proposalIdsBody
      },
      options
    );
  };
  const estimateChatControllerRejectProposals = (estimateId, chatId, proposalIdsBody, options) => {
    return customInstance(
      {
        url: `/rest/estimates/${estimateId}/chats/${chatId}/proposals/reject`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: proposalIdsBody
      },
      options
    );
  };
  const testControllerFulfillment = (options) => {
    return customInstance({ url: `/rest/test/fulfillment`, method: "POST" }, options);
  };
  const testControllerProcessPdf2 = (testControllerProcessPdf2Body, options) => {
    return customInstance(
      {
        url: `/rest/test/processPdf2`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: testControllerProcessPdf2Body
      },
      options
    );
  };
  const testControllerXactimateMapping = (options) => {
    return customInstance({ url: `/rest/test/getXactimateMapping`, method: "GET" }, options);
  };
  const testControllerProcessCachedEmail = (options) => {
    return customInstance({ url: `/rest/test/processCachedEmail`, method: "GET" }, options);
  };
  const testControllerProcessEmail = (options) => {
    return customInstance({ url: `/rest/test/processEmail`, method: "POST" }, options);
  };
  const testControllerGetJob = (params, options) => {
    return customInstance({ url: `/rest/test/getJob`, method: "GET", params }, options);
  };
  const testControllerLoadJobs = (options) => {
    return customInstance({ url: `/rest/test/loadJobs`, method: "GET" }, options);
  };
  const testControllerSaveTemplateData = (testControllerSaveTemplateDataBody, options) => {
    return customInstance(
      {
        url: `/rest/test/saveTemplateData`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: testControllerSaveTemplateDataBody
      },
      options
    );
  };
  const testControllerLoadTemplateData = (options) => {
    return customInstance({ url: `/rest/test/loadTemplateData`, method: "GET" }, options);
  };
  const testControllerCreateNewJob = (testControllerCreateNewJobBody, options) => {
    return customInstance(
      {
        url: `/rest/test/createNewJob`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: testControllerCreateNewJobBody
      },
      options
    );
  };
  const testControllerProcessPdfTestGet = (options) => {
    return customInstance({ url: `/rest/test/processPdfTestGet`, method: "GET" }, options);
  };
  const testControllerProcessPdf = (testControllerProcessPdfBody, options) => {
    return customInstance(
      { url: `/rest/test/processPdf`, method: "POST", headers: { "Content-Type": "application/json" }, data: testControllerProcessPdfBody },
      options
    );
  };
  const testControllerProcessImage = (testControllerProcessImageBody, options) => {
    return customInstance(
      {
        url: `/rest/test/processImage`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: testControllerProcessImageBody
      },
      options
    );
  };
  const testControllerUploadImage = (testControllerUploadImageBody, options) => {
    return customInstance(
      { url: `/rest/test/upload`, method: "POST", headers: { "Content-Type": "application/json" }, data: testControllerUploadImageBody },
      options
    );
  };
  const accessControlControllerInviteUserToOrganization = (accessControlControllerInviteUserToOrganizationBody, options) => {
    return customInstance(
      {
        url: `/rest/access/inviteUserToOrganization`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerInviteUserToOrganizationBody
      },
      options
    );
  };
  const accessControlControllerListOrganizations = (accessControlControllerListOrganizationsBody, options) => {
    return customInstance(
      { url: `/rest/access/listOrganizations`, method: "GET", headers: { "Content-Type": "application/json" } },
      options
    );
  };
  const accessControlControllerEditUser = (accessControlControllerEditUserBody, options) => {
    return customInstance(
      {
        url: `/rest/access/editUser`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerEditUserBody
      },
      options
    );
  };
  const accessControlControllerCreateOrganization = (accessControlControllerCreateOrganizationBody, options) => {
    return customInstance(
      {
        url: `/rest/access/createOrganization`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerCreateOrganizationBody
      },
      options
    );
  };
  const accessControlControllerEditOrganization = (accessControlControllerEditOrganizationBody, options) => {
    return customInstance(
      {
        url: `/rest/access/editOrganization`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerEditOrganizationBody
      },
      options
    );
  };
  const accessControlControllerDeleteUser = (organizationId, userId, options) => {
    return customInstance({ url: `/rest/access/organization/${organizationId}/user/${userId}`, method: "DELETE" }, options);
  };
  const accessControlControllerRegisterNewUser = (accessControlControllerRegisterNewUserBody, options) => {
    return customInstance(
      {
        url: `/rest/access/registerNewUser`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerRegisterNewUserBody
      },
      options
    );
  };
  const accessControlControllerAllActiveComplements = (options) => {
    return customInstance({ url: `/rest/access/allActiveComplements`, method: "GET" }, options);
  };
  const accessControlControllerSaveOrganizationTpaRules = (accessControlControllerSaveOrganizationTpaRulesBody, options) => {
    return customInstance(
      {
        url: `/rest/access/saveOrganizationTPARules`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerSaveOrganizationTpaRulesBody
      },
      options
    );
  };
  const accessControlControllerUpdateMyUser = (accessControlControllerUpdateMyUserBody, options) => {
    return customInstance(
      {
        url: `/rest/access/updateMyUser`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerUpdateMyUserBody
      },
      options
    );
  };
  const accessControlControllerCreateToken = (options) => {
    return customInstance({ url: `/rest/access/createToken`, method: "GET" }, options);
  };
  const accessControlControllerSendSignInLink = (params, options) => {
    return customInstance({ url: `/rest/access/sendSignInLink`, method: "GET", params }, options);
  };
  const accessControlControllerCheckCode = (params, options) => {
    return customInstance({ url: `/rest/access/checkCode`, method: "GET", params }, options);
  };
  const accessControlControllerGetUserDetails = (accessControlControllerGetUserDetailsBody, options) => {
    return customInstance(
      {
        url: `/rest/access/getUserDetails`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerGetUserDetailsBody
      },
      options
    );
  };
  const accessControlControllerGetFeatures = (options) => {
    return customInstance({ url: `/rest/access/organization/features`, method: "GET" }, options);
  };
  const accessControlControllerGetOrganizationFeatures = (organizationId, options) => {
    return customInstance({ url: `/rest/access/organization/${organizationId}/features`, method: "GET" }, options);
  };
  const accessControlControllerUpdateFeatures = (organizationId, accessControlControllerUpdateFeaturesBody, options) => {
    return customInstance(
      {
        url: `/rest/access/organization/${organizationId}/features`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerUpdateFeaturesBody
      },
      options
    );
  };
  const accessControlControllerGetPdfExportConfig = (organizationId, options) => {
    return customInstance({ url: `/rest/access/organization/${organizationId}/pdfExportConfig`, method: "GET" }, options);
  };
  const accessControlControllerUpdatePdfExportConfig = (organizationId, accessControlControllerUpdatePdfExportConfigBody, options) => {
    return customInstance(
      {
        url: `/rest/access/organization/${organizationId}/pdfExportConfig`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerUpdatePdfExportConfigBody
      },
      options
    );
  };
  const accessControlControllerGetCrmIntegrations = (organizationId, options) => {
    return customInstance({ url: `/rest/access/organization/${organizationId}/crmIntegrations`, method: "GET" }, options);
  };
  const accessControlControllerUpdateCrmIntegrations = (organizationId, accessControlControllerUpdateCrmIntegrationsBody, options) => {
    return customInstance(
      {
        url: `/rest/access/organization/${organizationId}/crmIntegrations`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: accessControlControllerUpdateCrmIntegrationsBody
      },
      options
    );
  };
  const accessControlControllerLogout = (options) => {
    return customInstance({ url: `/rest/access/logout`, method: "POST" }, options);
  };
  const valueAddCalculationControllerGetApprovedEstimates = (params, options) => {
    return customInstance({ url: `/rest/valueadd/analytics`, method: "GET", params }, options);
  };
  const xcelerateWebhookControllerHandleWebhook = (orgId, xcelerateWebhookControllerHandleWebhookBody, options) => {
    return customInstance(
      {
        url: `/rest/xcelerate/webhook/v1/create/${orgId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: xcelerateWebhookControllerHandleWebhookBody
      },
      options
    );
  };
  const xcelerateWebhookControllerRegisterWebhook = (orgId, xcelerateWebhookControllerRegisterWebhookBody, options) => {
    return customInstance(
      {
        url: `/rest/xcelerate/webhook/register/${orgId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: xcelerateWebhookControllerRegisterWebhookBody
      },
      options
    );
  };
  const xcelerateRedirectControllerRedirectEstimate = (estimateId, options) => {
    return customInstance({ url: `/rest/xcelerate/redirect/estimate/${estimateId}`, method: "GET" }, options);
  };
  const albiWebhookControllerRegisterWebhookForInstance = (orgId, integrationId, options) => {
    return customInstance(
      { url: `/rest/albi/webhook/register/${orgId}/${integrationId}`, method: "POST" },
      options
    );
  };
  const albiWebhookControllerHandleWebhookForInstance = (orgId, integrationId, albiWebhookControllerHandleWebhookForInstanceBody, options) => {
    return customInstance(
      {
        url: `/rest/albi/webhook/${orgId}/${integrationId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: albiWebhookControllerHandleWebhookForInstanceBody
      },
      options
    );
  };
  const veriskTpiCallbackControllerCallback = (veriskTpiCallbackControllerCallbackBody, options) => {
    return customInstance(
      {
        url: `/rest/verisk-tpi/callback`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: veriskTpiCallbackControllerCallbackBody
      },
      options
    );
  };
  const veriskTpiCallbackControllerRegisterCallback = (options) => {
    return customInstance({ url: `/rest/verisk-tpi/callback/register`, method: "POST" }, options);
  };
  const v2ControllerGetUser = (options) => {
    return customInstance({ url: `/rest/v2/user`, method: "GET" }, options);
  };
  const v2ControllerGetOrganizationSettings = (options) => {
    return customInstance({ url: `/rest/v2/organizationSettings`, method: "GET" }, options);
  };
  const v2ControllerGetUsers = (options) => {
    return customInstance({ url: `/rest/v2/users`, method: "GET" }, options);
  };
  const v2ControllerRegisterNewUser = (v2ControllerRegisterNewUserBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/registerNewUser`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2ControllerRegisterNewUserBody
      },
      options
    );
  };
  const v2ControllerUploadFile = (v2ControllerUploadFileBody, options) => {
    const formData = new FormData();
    if (v2ControllerUploadFileBody?.file !== void 0) {
      formData.append(`file`, v2ControllerUploadFileBody.file);
    }
    if (v2ControllerUploadFileBody?.estimateId !== void 0) {
      formData.append(`estimateId`, v2ControllerUploadFileBody.estimateId);
    }
    if (v2ControllerUploadFileBody?.uploadId !== void 0) {
      formData.append(`uploadId`, v2ControllerUploadFileBody.uploadId);
    }
    return customInstance({ url: `/rest/v2/files`, method: "POST", data: formData }, options);
  };
  const v2ControllerGetFeatures = (options) => {
    return customInstance({ url: `/rest/v2/organization/features`, method: "GET" }, options);
  };
  const v2ControllerTranscriptToScopeNotes = (v2ControllerTranscriptToScopeNotesBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/documentation/transcriptToScopeNotes`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2ControllerTranscriptToScopeNotesBody
      },
      options
    );
  };
  const v2ControllerGetConversation = (conversationId, params, options) => {
    return customInstance({ url: `/rest/v2/conversations/${conversationId}`, method: "GET", params }, options);
  };
  const v2ControllerGetReeseRnResumeContext = (v2ControllerGetReeseRnResumeContextBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/conversations/resume-context`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2ControllerGetReeseRnResumeContextBody
      },
      options
    );
  };
  const v2ControllerGetSystemPrompt = (params, options) => {
    return customInstance({ url: `/rest/v2/organizations/systemPrompt`, method: "GET", params }, options);
  };
  const v2ControllerLogout = (options) => {
    return customInstance({ url: `/rest/v2/logout`, method: "POST" }, options);
  };
  const v2EstimatesControllerGetEstimates = (params, options) => {
    return customInstance({ url: `/rest/v2/estimates/dashboardlist`, method: "GET", params, responseType: "blob" }, options);
  };
  const v2EstimatesControllerGetEstimate = (estimateId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}`, method: "GET", responseType: "blob" }, options);
  };
  const v2EstimatesControllerUpdateEstimate = (estimateId, v2EstimatesControllerUpdateEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerUpdateEstimateBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerApplyTpaRules = (applyTPARulesBody, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/applyTPARules`, method: "POST", headers: { "Content-Type": "application/json" }, data: applyTPARulesBody },
      options
    );
  };
  const v2EstimatesControllerCreateEstimate = (v2EstimatesControllerCreateEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerCreateEstimateBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerUpdateScopeNotes = (estimateId, v2EstimatesControllerUpdateScopeNotesBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/documentation`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerUpdateScopeNotesBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerAddScopeNoteToEstimate = (estimateId, v2EstimatesControllerAddScopeNoteToEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/documentation`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerAddScopeNoteToEstimateBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerValidatePdfExport = (estimateId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/validatePDFExport`, method: "GET", responseType: "blob" },
      options
    );
  };
  const v2EstimatesControllerGetZipTaxRate = (v2EstimatesControllerGetZipTaxRateBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/zipTaxRate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerGetZipTaxRateBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerExportToPdf = (estimateId, v2EstimatesControllerExportToPdfBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/exportToPDF`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerExportToPdfBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerGetPdfPreviewData = (estimateId, v2EstimatesControllerGetPdfPreviewDataBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/pdfPreviewData`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: v2EstimatesControllerGetPdfPreviewDataBody,
        responseType: "blob"
      },
      options
    );
  };
  const v2EstimatesControllerArchive = (archiveEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/archive`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: archiveEstimateBody,
        responseType: "blob"
      },
      options
    );
  };
  const intakeNoteControllerGetIntakeNotes = (estimateId, params, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes`, method: "GET", params },
      options
    );
  };
  const intakeNoteControllerCreateIntakeNote = (estimateId, createIntakeNoteBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createIntakeNoteBody
      },
      options
    );
  };
  const intakeNoteControllerGetIntakeNote = (estimateId, intakeNoteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}`, method: "GET" },
      options
    );
  };
  const intakeNoteControllerUpdateIntakeNote = (estimateId, intakeNoteId, updateIntakeNoteBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateIntakeNoteBody
      },
      options
    );
  };
  const intakeNoteControllerDeleteIntakeNote = (estimateId, intakeNoteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}`, method: "DELETE", responseType: "blob" },
      options
    );
  };
  const intakeNoteControllerSubmitIntakeNote = (estimateId, intakeNoteId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/submit`, method: "POST" }, options);
  };
  const intakeNoteControllerCompileSubsequentIntakeNote = (estimateId, intakeNoteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/compile`, method: "POST" },
      options
    );
  };
  const intakeNoteControllerGetIntakeNoteResponse = (estimateId, intakeNoteId, responseId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/responses/${responseId}`, method: "GET", responseType: "blob" },
      options
    );
  };
  const intakeNoteControllerCreateIntakeNoteModuleResponse = (estimateId, intakeNoteId, intakeNoteControllerCreateIntakeNoteModuleResponseBody, options) => {
    const formData = new FormData();
    if (intakeNoteControllerCreateIntakeNoteModuleResponseBody?.audio !== void 0) {
      formData.append(`audio`, intakeNoteControllerCreateIntakeNoteModuleResponseBody.audio);
    }
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/responses`,
        method: "POST",
        data: formData,
        responseType: "blob"
      },
      options
    );
  };
  const roomControllerGetRooms = (estimateId, intakeNoteId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms`, method: "GET" }, options);
  };
  const roomControllerCreateRoom = (estimateId, intakeNoteId, createRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createRoomBody
      },
      options
    );
  };
  const roomControllerGetRoom = (estimateId, intakeNoteId, roomId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}`, method: "GET" },
      options
    );
  };
  const roomControllerUpdateRoom = (estimateId, intakeNoteId, roomId, updateRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateRoomBody
      },
      options
    );
  };
  const roomControllerDeleteRoom = (estimateId, intakeNoteId, roomId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}`, method: "DELETE" },
      options
    );
  };
  const roomControllerDuplicateRoom = (estimateId, intakeNoteId, roomId, duplicateRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/duplicate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: duplicateRoomBody
      },
      options
    );
  };
  const roomControllerCompleteRoom = (estimateId, intakeNoteId, roomId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/complete`, method: "POST" },
      options
    );
  };
  const moduleResponseControllerGetModuleResponses = (estimateId, intakeNoteId, roomId, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses`,
        method: "GET",
        responseType: "blob"
      },
      options
    );
  };
  const moduleResponseControllerCreateModuleResponse = (estimateId, intakeNoteId, roomId, moduleResponseControllerCreateModuleResponseBody, options) => {
    const formData = new FormData();
    if (moduleResponseControllerCreateModuleResponseBody?.audio !== void 0) {
      formData.append(`audio`, moduleResponseControllerCreateModuleResponseBody.audio);
    }
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses`,
        method: "POST",
        data: formData,
        responseType: "blob"
      },
      options
    );
  };
  const moduleResponseControllerGetModuleResponse = (estimateId, intakeNoteId, roomId, moduleResponseId, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses/${moduleResponseId}`,
        method: "GET",
        responseType: "blob"
      },
      options
    );
  };
  const moduleResponseControllerUpdateModuleResponse = (estimateId, intakeNoteId, roomId, moduleResponseId, moduleResponseControllerUpdateModuleResponseBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses/${moduleResponseId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: moduleResponseControllerUpdateModuleResponseBody,
        responseType: "blob"
      },
      options
    );
  };
  const moduleResponseControllerDeleteModuleResponse = (estimateId, intakeNoteId, roomId, moduleResponseId, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses/${moduleResponseId}`,
        method: "DELETE",
        responseType: "blob"
      },
      options
    );
  };
  const moduleResponseControllerBulkSkipModuleResponses = (estimateId, intakeNoteId, roomId, bulkSkipModuleResponsesBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses/bulkSkip`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: bulkSkipModuleResponsesBody
      },
      options
    );
  };
  const moduleResponseControllerCreateFollowUpResponse = (estimateId, intakeNoteId, roomId, moduleResponseId, moduleResponseControllerCreateFollowUpResponseBody, options) => {
    const formData = new FormData();
    if (moduleResponseControllerCreateFollowUpResponseBody?.audio !== void 0) {
      formData.append(`audio`, moduleResponseControllerCreateFollowUpResponseBody.audio);
    }
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses/${moduleResponseId}/followUpResponse`,
        method: "POST",
        data: formData,
        responseType: "blob"
      },
      options
    );
  };
  const moduleResponseControllerUploadModuleResponseAudio = (estimateId, intakeNoteId, roomId, moduleResponseId, moduleResponseControllerUploadModuleResponseAudioBody, options) => {
    const formData = new FormData();
    if (moduleResponseControllerUploadModuleResponseAudioBody?.audio !== void 0) {
      formData.append(`audio`, moduleResponseControllerUploadModuleResponseAudioBody.audio);
    }
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/intakeNotes/${intakeNoteId}/rooms/${roomId}/moduleResponses/${moduleResponseId}/audio`,
        method: "POST",
        data: formData,
        responseType: "blob"
      },
      options
    );
  };
  const responsiveNoteControllerGetResponsiveNotes = (estimateId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes`, method: "GET" },
      options
    );
  };
  const responsiveNoteControllerCreateResponsiveNote = (estimateId, createResponsiveNoteBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createResponsiveNoteBody
      },
      options
    );
  };
  const responsiveNoteControllerCreatePhotoPresignedUrl = (estimateId, noteId, createResponsiveNotePhotoPresignedUrlBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/photos/presigned-url`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createResponsiveNotePhotoPresignedUrlBody
      },
      options
    );
  };
  const responsiveNoteControllerCompletePhotoUpload = (estimateId, noteId, photoId, createResponsiveNotePhotoPresignedUrlBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/photos/${photoId}/complete`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createResponsiveNotePhotoPresignedUrlBody
      },
      options
    );
  };
  const responsiveNoteControllerGetResponsiveNote = (estimateId, noteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}`, method: "GET" },
      options
    );
  };
  const responsiveNoteControllerUpdateResponsiveNote = (estimateId, noteId, updateResponsiveNoteBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateResponsiveNoteBody
      },
      options
    );
  };
  const responsiveNoteControllerSubmitResponsiveNote = (estimateId, noteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/submit`, method: "POST" },
      options
    );
  };
  const responsiveNoteControllerGetPhotos = (estimateId, noteId, params, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/photos`, method: "GET", params },
      options
    );
  };
  const responsiveNoteControllerCreatePhoto = (estimateId, noteId, responsiveNoteControllerCreatePhotoBody, options) => {
    const formData = new FormData();
    formData.append(`photo`, responsiveNoteControllerCreatePhotoBody.photo);
    formData.append(`id`, responsiveNoteControllerCreatePhotoBody.id);
    if (responsiveNoteControllerCreatePhotoBody.parentBlockId !== void 0) {
      formData.append(`parentBlockId`, responsiveNoteControllerCreatePhotoBody.parentBlockId);
    }
    if (responsiveNoteControllerCreatePhotoBody.capturedAt !== void 0) {
      formData.append(`capturedAt`, responsiveNoteControllerCreatePhotoBody.capturedAt);
    }
    if (responsiveNoteControllerCreatePhotoBody.width !== void 0) {
      formData.append(`width`, responsiveNoteControllerCreatePhotoBody.width);
    }
    if (responsiveNoteControllerCreatePhotoBody.height !== void 0) {
      formData.append(`height`, responsiveNoteControllerCreatePhotoBody.height);
    }
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/photos`, method: "POST", data: formData },
      options
    );
  };
  const responsiveNoteControllerDeletePhoto = (estimateId, noteId, photoId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/photos/${photoId}`, method: "DELETE", responseType: "blob" },
      options
    );
  };
  const responsiveNoteControllerProcessVoiceTranscript = (estimateId, noteId, createResponsiveNoteVoiceTranscriptBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/voice-transcripts`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createResponsiveNoteVoiceTranscriptBody
      },
      options
    );
  };
  const responsiveNoteControllerGetVoiceTranscripts = (estimateId, noteId, params, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/voice-transcripts`, method: "GET", params },
      options
    );
  };
  const responsiveNoteControllerGetVoiceTranscript = (estimateId, noteId, transcriptId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/voice-transcripts/${transcriptId}`, method: "GET" },
      options
    );
  };
  const responsiveNoteControllerGetFollowUpQuestionCounts = (estimateId, noteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/follow-up-questions/counts`, method: "GET" },
      options
    );
  };
  const responsiveNoteControllerGetFollowUpQuestions = (estimateId, noteId, params, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/follow-up-questions`, method: "GET", params },
      options
    );
  };
  const responsiveNoteControllerAnswerFollowUpQuestion = (estimateId, noteId, questionId, answerResponsiveNoteFollowUpQuestionBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/follow-up-questions/${questionId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: answerResponsiveNoteFollowUpQuestionBody
      },
      options
    );
  };
  const responsiveNoteControllerDismissFollowUpQuestion = (estimateId, noteId, questionId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/follow-up-questions/${questionId}/dismiss`, method: "POST" },
      options
    );
  };
  const responsiveNoteControllerArchiveResponsiveNote = (estimateId, noteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/archive`, method: "POST", responseType: "blob" },
      options
    );
  };
  const blockControllerGetBlocks = (estimateId, noteId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/blocks`, method: "GET" },
      options
    );
  };
  const blockControllerUpsertBlock = (estimateId, noteId, createBlockBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/blocks`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createBlockBody
      },
      options
    );
  };
  const blockControllerBatchBlocks = (estimateId, noteId, batchBlocksBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/blocks/batch`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: batchBlocksBody
      },
      options
    );
  };
  const blockControllerUpdateBlock = (estimateId, noteId, blockId, updateBlockBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/blocks/${blockId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateBlockBody
      },
      options
    );
  };
  const blockControllerArchiveBlock = (estimateId, noteId, blockId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/responsiveNotes/${noteId}/blocks/${blockId}/archive`, method: "POST", responseType: "blob" },
      options
    );
  };
  const spaceControllerCreateSpace = (estimateId, createSpaceBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/spaces`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createSpaceBody
      },
      options
    );
  };
  const spaceControllerGetSpaces = (estimateId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/spaces`, method: "GET" }, options);
  };
  const spaceControllerGetSpace = (estimateId, spaceId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/spaces/${spaceId}`, method: "GET" }, options);
  };
  const spaceControllerUpdateSpace = (estimateId, spaceId, updateSpaceBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/spaces/${spaceId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateSpaceBody
      },
      options
    );
  };
  const spaceControllerArchiveSpace = (estimateId, spaceId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/spaces/${spaceId}/archive`, method: "POST" },
      options
    );
  };
  const lineItemControllerSearchLineItems = (estimateId, params, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/lineItems/search`, method: "GET", params },
      options
    );
  };
  const lineItemControllerAddLineItem = (estimateId, addLineItemBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/lineItems`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: addLineItemBody
      },
      options
    );
  };
  const lineItemControllerUpdateLineItem = (estimateId, lineItemId, updateLineItemBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/lineItems/${lineItemId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateLineItemBody
      },
      options
    );
  };
  const lineItemControllerGetLineItemVariables = (estimateId, lineItemId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/lineItems/${lineItemId}/variables`, method: "GET" },
      options
    );
  };
  const lineItemControllerConfirmLineItem = (estimateId, id, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/lineItems/${id}/confirm`, method: "POST" }, options);
  };
  const lineItemControllerArchiveLineItem = (estimateId, id, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/lineItems/${id}/archive`, method: "POST" }, options);
  };
  const xactimateMappingControllerGetXactimateMappingsForEstimate = (estimateId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/xactimateMapping`, method: "GET" },
      options
    );
  };
  const xactimateMappingControllerGetMappingByTemplateId = (estimateId, params, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/xactimateMapping/lookup`, method: "GET", params },
      options
    );
  };
  const xactimateExportControllerValidate = (estimateId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/xactimateExport/validate`, method: "POST" },
      options
    );
  };
  const xactimateExportControllerExport = (estimateId, exportToXactimateBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/xactimateExport`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: exportToXactimateBody
      },
      options
    );
  };
  const xactimateExportControllerStartPhotoUpload = (estimateId, startPhotoUploadBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/xactimateExport/photos`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: startPhotoUploadBody
      },
      options
    );
  };
  const estimateRoomControllerCreateRoom = (estimateId, createEstimateRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/rooms`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createEstimateRoomBody
      },
      options
    );
  };
  const estimateRoomControllerUpdateRoom = (estimateId, roomId, updateRoomBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/rooms/${roomId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateRoomBody
      },
      options
    );
  };
  const estimateRoomControllerArchiveRoom = (estimateId, roomId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/rooms/${roomId}/archive`, method: "POST" },
      options
    );
  };
  const spaceScanControllerListScans = (estimateId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/spaceScans`, method: "GET" }, options);
  };
  const spaceScanControllerGetScan = (estimateId, spaceId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/spaceScans/${spaceId}`, method: "GET" }, options);
  };
  const spaceScanControllerUpsertScan = (estimateId, spaceId, spaceScanControllerUpsertScanBody, options) => {
    const formData = new FormData();
    if (spaceScanControllerUpsertScanBody.usdz !== void 0) {
      formData.append(`usdz`, spaceScanControllerUpsertScanBody.usdz);
    }
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/spaceScans/${spaceId}`, method: "PUT", data: formData },
      options
    );
  };
  const spaceScanControllerUpdateScan = (estimateId, spaceId, updateSpaceScanBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/spaceScans/${spaceId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateSpaceScanBody
      },
      options
    );
  };
  const spaceScanControllerDeleteScan = (estimateId, spaceId, options) => {
    return customInstance({ url: `/rest/v2/estimates/${estimateId}/spaceScans/${spaceId}`, method: "DELETE" }, options);
  };
  const spaceScanControllerGetSketch = (estimateId, spaceId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/spaceScans/${spaceId}/sketch`, method: "GET" },
      options
    );
  };
  const photoReportControllerExport = (estimateId, exportPhotoReportBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/estimates/${estimateId}/photoReport/export`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: exportPhotoReportBody,
        responseType: "blob"
      },
      options
    );
  };
  const photoReportControllerLetterhead = (estimateId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/photoReport/letterhead`, method: "GET" },
      options
    );
  };
  const photoReportControllerPhotos = (estimateId, options) => {
    return customInstance(
      { url: `/rest/v2/estimates/${estimateId}/photoReport/photos`, method: "GET" },
      options
    );
  };
  const moduleTemplateControllerGetModules = (params, options) => {
    return customInstance({ url: `/rest/v2/moduletemplates`, method: "GET", params, responseType: "blob" }, options);
  };
  const moduleTemplateControllerCreateModule = (moduleTemplateControllerCreateModuleBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/moduletemplates`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: moduleTemplateControllerCreateModuleBody,
        responseType: "blob"
      },
      options
    );
  };
  const moduleTemplateControllerGetBulkModulesForIntake = (options) => {
    return customInstance({ url: `/rest/v2/moduletemplates/for-intake/bulk`, method: "GET" }, options);
  };
  const moduleTemplateControllerGetModulesForIntake = (params, options) => {
    return customInstance({ url: `/rest/v2/moduletemplates/for-intake`, method: "GET", params }, options);
  };
  const moduleTemplateControllerUpdateModule = (id, moduleTemplateControllerUpdateModuleBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/moduletemplates/${id}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: moduleTemplateControllerUpdateModuleBody,
        responseType: "blob"
      },
      options
    );
  };
  const moduleTemplateControllerDeleteModule = (id, params, options) => {
    return customInstance({ url: `/rest/v2/moduletemplates/${id}`, method: "DELETE", params, responseType: "blob" }, options);
  };
  const responsiveNoteTemplateControllerGetTemplates = (params, options) => {
    return customInstance(
      { url: `/rest/v2/responsiveNoteTemplates`, method: "GET", params },
      options
    );
  };
  const responsiveNoteTemplateControllerGetBulkTemplatesForPrefetch = (options) => {
    return customInstance(
      { url: `/rest/v2/responsiveNoteTemplates/prefetch/bulk`, method: "GET" },
      options
    );
  };
  const responsiveNoteTemplateControllerGetTemplate = (templateId, params, options) => {
    return customInstance(
      { url: `/rest/v2/responsiveNoteTemplates/${templateId}`, method: "GET", params },
      options
    );
  };
  const appVersionControllerCheckVersion = (params, options) => {
    return customInstance({ url: `/rest/v2/app/version/check`, method: "GET", params }, options);
  };
  const appWarningsControllerCheckWarnings = (options) => {
    return customInstance({ url: `/rest/v2/app/warnings/check`, method: "GET" }, options);
  };
  const voiceControllerCreateSession = (options) => {
    return customInstance({ url: `/rest/v2/voice/session`, method: "GET" }, options);
  };
  const voiceControllerTranscribeRecording = (voiceControllerTranscribeRecordingBody, options) => {
    const formData = new FormData();
    if (voiceControllerTranscribeRecordingBody?.audio !== void 0) {
      formData.append(`audio`, voiceControllerTranscribeRecordingBody.audio);
    }
    return customInstance({ url: `/rest/v2/voice/transcribe`, method: "POST", data: formData }, options);
  };
  const jobControllerGetJob = (jobId, options) => {
    return customInstance({ url: `/rest/v2/jobs/${jobId}`, method: "GET" }, options);
  };
  const jobControllerGetJobsForEstimate = (estimateId, options) => {
    return customInstance({ url: `/rest/v2/jobs/estimates/${estimateId}`, method: "GET" }, options);
  };
  const userPreferencesControllerGetUserPreferences = (options) => {
    return customInstance({ url: `/rest/v2/userPreferences`, method: "GET" }, options);
  };
  const userPreferencesControllerUpdateUserPreferences = (updateUserPreferenceBody, options) => {
    return customInstance(
      { url: `/rest/v2/userPreferences`, method: "PATCH", headers: { "Content-Type": "application/json" }, data: updateUserPreferenceBody },
      options
    );
  };
  const rateCardV2ControllerListRateCards = (options) => {
    return customInstance({ url: `/rest/v2/rate-cards`, method: "GET" }, options);
  };
  const rateCardV2ControllerGetRateCard = (rateCardId, options) => {
    return customInstance({ url: `/rest/v2/rate-cards/${rateCardId}`, method: "GET" }, options);
  };
  const tpaV2ControllerList = (params, options) => {
    return customInstance({ url: `/rest/v2/tpas`, method: "GET", params }, options);
  };
  const tpaV2ControllerGetById = (id, options) => {
    return customInstance({ url: `/rest/v2/tpas/${id}`, method: "GET" }, options);
  };
  const carrierV2ControllerList = (params, options) => {
    return customInstance({ url: `/rest/v2/carriers`, method: "GET", params }, options);
  };
  const carrierV2ControllerGetById = (id, options) => {
    return customInstance({ url: `/rest/v2/carriers/${id}`, method: "GET" }, options);
  };
  const failedOfflineSyncMutationControllerCreateFailedMutations = (createFailedMutationsBody, options) => {
    return customInstance(
      { url: `/rest/v2/failedMutations`, method: "POST", headers: { "Content-Type": "application/json" }, data: createFailedMutationsBody },
      options
    );
  };
  const failedOfflineSyncMutationControllerGetFailedCascades = (params, options) => {
    return customInstance({ url: `/rest/v2/failedMutations`, method: "GET", params }, options);
  };
  const failedOfflineSyncMutationControllerUpdateFailedMutationStatus = (updateFailedMutationStatusBody, options) => {
    return customInstance(
      {
        url: `/rest/v2/failedMutations/status`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateFailedMutationStatusBody
      },
      options
    );
  };
  const failedOfflineSyncMutationControllerGetCascadeMutations = (cascadeId, params, options) => {
    return customInstance(
      { url: `/rest/v2/failedMutations/${cascadeId}/mutations`, method: "GET", params },
      options
    );
  };
  const toolsControllerGetOrganizations = (options) => {
    return customInstance({ url: `/rest/tools/organizations`, method: "GET", responseType: "blob" }, options);
  };
  const internalXactimateMappingsControllerGetXactimateMappings = (params, options) => {
    return customInstance({ url: `/rest/tools/xactimateMappings`, method: "GET", params }, options);
  };
  const internalXactimateMappingsControllerBatchSetXactimateMappings = (internalXactimateMappingsControllerBatchSetXactimateMappingsBody, options) => {
    return customInstance(
      {
        url: `/rest/tools/xactimateMappings/batch`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: internalXactimateMappingsControllerBatchSetXactimateMappingsBody
      },
      options
    );
  };
  const internalXactimateMappingsControllerSetXactimateMapping = (mappingId, internalXactimateMappingsControllerSetXactimateMappingBody, options) => {
    return customInstance(
      {
        url: `/rest/tools/xactimateMappings/${mappingId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: internalXactimateMappingsControllerSetXactimateMappingBody
      },
      options
    );
  };
  const internalXactimateMappingsControllerDeleteXactimateMapping = (mappingId, options) => {
    return customInstance({ url: `/rest/tools/xactimateMappings/${mappingId}`, method: "DELETE" }, options);
  };
  const sourceTextsToSkipControllerListSourceTextsToSkip = (options) => {
    return customInstance({ url: `/rest/tools/sourceTextsToSkip`, method: "GET" }, options);
  };
  const sourceTextsToSkipControllerCreateSourceTextToSkip = (saveSourceTextToSkipBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/sourceTextsToSkip`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: saveSourceTextToSkipBodyModel
      },
      options
    );
  };
  const sourceTextsToSkipControllerUpdateSourceTextToSkip = (id, saveSourceTextToSkipBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/sourceTextsToSkip/${id}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: saveSourceTextToSkipBodyModel
      },
      options
    );
  };
  const sourceTextsToSkipControllerDeleteSourceTextToSkip = (id, options) => {
    return customInstance({ url: `/rest/tools/sourceTextsToSkip/${id}`, method: "DELETE", responseType: "blob" }, options);
  };
  const managedResponsiveNoteTemplateControllerGetTemplates = (params, options) => {
    return customInstance(
      { url: `/rest/tools/managedResponsiveNoteTemplates`, method: "GET", params },
      options
    );
  };
  const managedResponsiveNoteTemplateControllerCreateTemplate = (saveResponsiveNoteTemplateBodyModel, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/managedResponsiveNoteTemplates`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: saveResponsiveNoteTemplateBodyModel,
        params
      },
      options
    );
  };
  const managedResponsiveNoteTemplateControllerGetTemplate = (templateId, params, options) => {
    return customInstance(
      { url: `/rest/tools/managedResponsiveNoteTemplates/${templateId}`, method: "GET", params },
      options
    );
  };
  const managedResponsiveNoteTemplateControllerUpdateTemplate = (templateId, saveResponsiveNoteTemplateBodyModel, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/managedResponsiveNoteTemplates/${templateId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: saveResponsiveNoteTemplateBodyModel,
        params
      },
      options
    );
  };
  const managedResponsiveNoteTemplateControllerArchiveTemplate = (templateId, params, options) => {
    return customInstance(
      { url: `/rest/tools/managedResponsiveNoteTemplates/${templateId}`, method: "DELETE", params, responseType: "blob" },
      options
    );
  };
  const managedRateCardControllerListRateCards = (params, options) => {
    return customInstance({ url: `/rest/tools/rate-cards`, method: "GET", params }, options);
  };
  const managedRateCardControllerCreateRateCard = (createRateCardRequest, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/rate-cards`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createRateCardRequest,
        params
      },
      options
    );
  };
  const managedRateCardControllerGetRateCard = (rateCardId, params, options) => {
    return customInstance({ url: `/rest/tools/rate-cards/${rateCardId}`, method: "GET", params }, options);
  };
  const managedRateCardControllerUpdateRateCard = (rateCardId, updateRateCardRequest, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/rate-cards/${rateCardId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateRateCardRequest,
        params
      },
      options
    );
  };
  const managedRateCardControllerDeleteRateCard = (rateCardId, params, options) => {
    return customInstance({ url: `/rest/tools/rate-cards/${rateCardId}`, method: "DELETE", params, responseType: "blob" }, options);
  };
  const managedRateCardControllerCreateRateItem = (rateCardId, createRateItemInput, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/rate-cards/${rateCardId}/rate-items`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createRateItemInput,
        params
      },
      options
    );
  };
  const managedRateCardControllerBulkCreateRateItems = (rateCardId, bulkCreateRateItemsRequest, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/rate-cards/${rateCardId}/rate-items/bulk`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: bulkCreateRateItemsRequest,
        params
      },
      options
    );
  };
  const managedRateCardControllerUpdateRateItem = (rateCardId, rateItemId, updateRateItemInput, params, options) => {
    return customInstance(
      {
        url: `/rest/tools/rate-cards/${rateCardId}/rate-items/${rateItemId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: updateRateItemInput,
        params
      },
      options
    );
  };
  const managedRateCardControllerDeleteRateItem = (rateCardId, rateItemId, params, options) => {
    return customInstance(
      { url: `/rest/tools/rate-cards/${rateCardId}/rate-items/${rateItemId}`, method: "DELETE", params, responseType: "blob" },
      options
    );
  };
  const managedRateCardControllerExtractRateItems = (managedRateCardControllerExtractRateItemsBody, params, options) => {
    const formData = new FormData();
    if (managedRateCardControllerExtractRateItemsBody?.file !== void 0) {
      formData.append(`file`, managedRateCardControllerExtractRateItemsBody.file);
    }
    return customInstance(
      { url: `/rest/tools/rate-cards/extract`, method: "POST", data: formData, params },
      options
    );
  };
  const customContextControllerListCustomContexts = (params, options) => {
    return customInstance({ url: `/rest/tools/customContext`, method: "GET", params }, options);
  };
  const customContextControllerCreateCustomContext = (saveCustomContextBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/customContext`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: saveCustomContextBodyModel
      },
      options
    );
  };
  const customContextControllerUpdateCustomContext = (id, saveCustomContextBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/customContext/${id}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: saveCustomContextBodyModel
      },
      options
    );
  };
  const customContextControllerDeleteCustomContext = (id, options) => {
    return customInstance({ url: `/rest/tools/customContext/${id}`, method: "DELETE", responseType: "blob" }, options);
  };
  const rulesControllerGetRules = (params, options) => {
    return customInstance({ url: `/rest/tools/rules`, method: "GET", params }, options);
  };
  const rulesControllerCreateRule = (saveRuleBody, options) => {
    return customInstance(
      { url: `/rest/tools/rules`, method: "POST", headers: { "Content-Type": "application/json" }, data: saveRuleBody },
      options
    );
  };
  const rulesControllerGetRuleById = (uuid, options) => {
    return customInstance({ url: `/rest/tools/rules/${uuid}`, method: "GET" }, options);
  };
  const rulesControllerUpdateRule = (uuid, saveRuleBody, options) => {
    return customInstance(
      { url: `/rest/tools/rules/${uuid}`, method: "PATCH", headers: { "Content-Type": "application/json" }, data: saveRuleBody },
      options
    );
  };
  const lineItemTemplateControllerSearchLineItemPermutations = (params, options) => {
    return customInstance({ url: `/rest/tools/lineItems/search`, method: "GET", params }, options);
  };
  const manualEstimateReviewControllerListManualEstimateReviewTrackers = (params, options) => {
    return customInstance(
      { url: `/rest/tools/manualEstimateReview`, method: "GET", params },
      options
    );
  };
  const manualEstimateReviewControllerCreateManualEstimateReview = (createManualEstimateReviewBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/manualEstimateReview`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createManualEstimateReviewBodyModel
      },
      options
    );
  };
  const manualEstimateReviewControllerUpdateManualEstimateReviewTracker = (id, updateManualEstimateReviewTrackerBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/manualEstimateReview/${id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: updateManualEstimateReviewTrackerBodyModel
      },
      options
    );
  };
  const agentConversationControllerStartSession = (startAgentSessionBodyModel, options) => {
    return customInstance(
      {
        url: `/rest/tools/agentConversations/sessions`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: startAgentSessionBodyModel
      },
      options
    );
  };
  const agentConversationControllerGetSessionStatus = (sessionId, params, options) => {
    return customInstance(
      { url: `/rest/tools/agentConversations/sessions/${sessionId}`, method: "GET", params },
      options
    );
  };
  const organizationsControllerGetNames = (options) => {
    return customInstance({ url: `/rest/organizations/names`, method: "GET" }, options);
  };
  const organizationsControllerGetSystemPrompt = (params, options) => {
    return customInstance({ url: `/rest/organizations/systemPrompt`, method: "GET", params }, options);
  };
  const tpaControllerList = (params, options) => {
    return customInstance({ url: `/rest/tpas`, method: "GET", params }, options);
  };
  const tpaControllerGetById = (id, options) => {
    return customInstance({ url: `/rest/tpas/${id}`, method: "GET" }, options);
  };
  const carrierControllerList = (params, options) => {
    return customInstance({ url: `/rest/carriers`, method: "GET", params }, options);
  };
  const carrierControllerGetById = (id, options) => {
    return customInstance({ url: `/rest/carriers/${id}`, method: "GET" }, options);
  };
  const feedbackControllerCreateLineItemFeedback = (createLineItemFeedbackBody, options) => {
    return customInstance(
      { url: `/rest/feedback/lineItem`, method: "POST", headers: { "Content-Type": "application/json" }, data: createLineItemFeedbackBody },
      options
    );
  };
  const webRateCardControllerListRateCards = (options) => {
    return customInstance({ url: `/rest/rate-cards`, method: "GET" }, options);
  };
  const webRateCardControllerGetRateCard = (rateCardId, options) => {
    return customInstance({ url: `/rest/rate-cards/${rateCardId}`, method: "GET" }, options);
  };
  const appScriptControllerHandleGoogleFormsSubmission = (appScriptControllerHandleGoogleFormsSubmissionBody, options) => {
    return customInstance(
      {
        url: `/rest/appscript/gurr/google_forms`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: appScriptControllerHandleGoogleFormsSubmissionBody
      },
      options
    );
  };
  const healthControllerHealthCheck = (options) => {
    return customInstance({ url: `/rest/health`, method: "GET" }, options);
  };
  const jobNimbusControllerHandleEstimate = (jobNimbusControllerHandleEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/jobnimbus/estimates`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: jobNimbusControllerHandleEstimateBody
      },
      options
    );
  };
  const firstAtlanticControllerHandleEstimate = (firstAtlanticControllerHandleEstimateBody, options) => {
    return customInstance(
      {
        url: `/rest/firstatlantic/estimates`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: firstAtlanticControllerHandleEstimateBody
      },
      options
    );
  };
  const psaControllerTriggerPoll = (options) => {
    return customInstance({ url: `/rest/psa/poll`, method: "POST" }, options);
  };
  const deployControllerGetState = (options) => {
    return customInstance({ url: `/rest/deploy/state`, method: "GET", responseType: "blob" }, options);
  };
  const deployControllerGetDiff = (params, options) => {
    return customInstance({ url: `/rest/deploy/diff`, method: "GET", params, responseType: "blob" }, options);
  };
  const deployControllerPromote = (promoteBody, options) => {
    return customInstance(
      {
        url: `/rest/deploy/promote`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: promoteBody,
        responseType: "blob"
      },
      options
    );
  };
  const deployControllerAuthenticate = (deployControllerAuthenticateBody, options) => {
    return customInstance(
      {
        url: `/rest/deploy/auth`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: deployControllerAuthenticateBody,
        responseType: "blob"
      },
      options
    );
  };
  const deployControllerReceiveEvents = (deployEventsBody, options) => {
    return customInstance(
      {
        url: `/rest/deploy/events`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: deployEventsBody,
        responseType: "blob"
      },
      options
    );
  };
  const jobControllerGetJobByJobId = (jobId, options) => {
    return customInstance({ url: `/rest/jobs/${jobId}`, method: "GET" }, options);
  };
  const jobControllerGetJobsForEstimateByEstimateId = (estimateId, options) => {
    return customInstance({ url: `/rest/jobs/estimates/${estimateId}`, method: "GET" }, options);
  };
  return {
    storageControllerGetFile,
    storageControllerUploadValueAddFile,
    storageControllerDeletePhotos,
    storageControllerUploadFile,
    estimatesControllerGetEstimateMetadata,
    estimatesControllerGetFinalEstimates,
    estimatesControllerGetResponsiveNotePhotos,
    estimatesControllerGetResponsiveNotePhotoLabels,
    estimatesControllerReassignResponsiveNotePhotos,
    estimatesControllerApplyResponsiveNotePhotoLabels,
    estimatesControllerGetXactimateMappingForLineItem,
    estimatesControllerGetXactimateMapping,
    estimatesControllerGetXactimateMappingByTemplate,
    estimatesControllerDuplicateEstimate,
    estimatesControllerGetEstimate,
    estimatesControllerCreateNewEstimateRequest,
    estimatesControllerGetEstimateRequests,
    estimatesControllerMergePages,
    estimatesControllerUpdateEstimaticsEstimate,
    estimatesControllerUpdateEstimateMitigationDetails,
    estimatesControllerArchive,
    estimatesControllerAddNote,
    estimatesControllerCreateEstimaticsEstimate,
    estimatesControllerAddEstimateRequestFiles,
    estimatesControllerRestoreDocument,
    estimatesControllerApplyTpaRules,
    estimatesControllerRevertAppliedTpaRules,
    estimatesControllerSetXatimateMappings,
    estimatesControllerSetMappings,
    estimatesControllerGetUserXactimateMapping,
    estimatesControllerAddUserXactimateMapping,
    estimatesControllerGetLineItemElements,
    estimatesControllerGetLineItemOrderIndex,
    estimatesControllerDeleteAll,
    estimatesControllerGenerateLineItemFromInput,
    estimatesControllerCopylineItemsForQa,
    estimatesControllerValidatePdfExport,
    estimatesControllerValidateXactimateExport,
    estimatesControllerExportTo1Pager,
    estimatesControllerExportPhotoReport,
    estimatesControllerGetPhotoReportLetterhead,
    estimatesControllerDownloadScopeNotes,
    estimatesControllerExportToXactimate,
    estimatesControllerStartXactimatePhotoUpload,
    estimatesControllerRejectFixedMapping,
    estimatesControllerGetFixedMapping,
    estimatesControllerGetLineItemById,
    estimatesControllerSearchLineItems,
    estimatesControllerSearchLineItemsV2,
    estimatesControllerUpdateOrCreateLineItem,
    estimatesControllerBatchUpdateOrCreateLineItems,
    estimatesControllerUpdateOrCreateFinalEstimateMetadata,
    estimatesControllerPasteLineItems,
    estimatesControllerValidateDocusketch,
    estimatesControllerValidateUploadedPdfFormat,
    estimatesControllerTranscriptToScopeNotes,
    estimatesControllerGetZipTaxRate,
    estimatesControllerGetPdfPreviewData,
    estimatesControllerCreateRoom,
    estimatesControllerArchiveRoom,
    estimateChatControllerListChats,
    estimateChatControllerGetMessages,
    estimateChatControllerPostMessage,
    estimateChatControllerUpdateChat,
    estimateChatControllerAcceptProposals,
    estimateChatControllerRejectProposals,
    testControllerFulfillment,
    testControllerProcessPdf2,
    testControllerXactimateMapping,
    testControllerProcessCachedEmail,
    testControllerProcessEmail,
    testControllerGetJob,
    testControllerLoadJobs,
    testControllerSaveTemplateData,
    testControllerLoadTemplateData,
    testControllerCreateNewJob,
    testControllerProcessPdfTestGet,
    testControllerProcessPdf,
    testControllerProcessImage,
    testControllerUploadImage,
    accessControlControllerInviteUserToOrganization,
    accessControlControllerListOrganizations,
    accessControlControllerEditUser,
    accessControlControllerCreateOrganization,
    accessControlControllerEditOrganization,
    accessControlControllerDeleteUser,
    accessControlControllerRegisterNewUser,
    accessControlControllerAllActiveComplements,
    accessControlControllerSaveOrganizationTpaRules,
    accessControlControllerUpdateMyUser,
    accessControlControllerCreateToken,
    accessControlControllerSendSignInLink,
    accessControlControllerCheckCode,
    accessControlControllerGetUserDetails,
    accessControlControllerGetFeatures,
    accessControlControllerGetOrganizationFeatures,
    accessControlControllerUpdateFeatures,
    accessControlControllerGetPdfExportConfig,
    accessControlControllerUpdatePdfExportConfig,
    accessControlControllerGetCrmIntegrations,
    accessControlControllerUpdateCrmIntegrations,
    accessControlControllerLogout,
    valueAddCalculationControllerGetApprovedEstimates,
    xcelerateWebhookControllerHandleWebhook,
    xcelerateWebhookControllerRegisterWebhook,
    xcelerateRedirectControllerRedirectEstimate,
    albiWebhookControllerRegisterWebhookForInstance,
    albiWebhookControllerHandleWebhookForInstance,
    veriskTpiCallbackControllerCallback,
    veriskTpiCallbackControllerRegisterCallback,
    v2ControllerGetUser,
    v2ControllerGetOrganizationSettings,
    v2ControllerGetUsers,
    v2ControllerRegisterNewUser,
    v2ControllerUploadFile,
    v2ControllerGetFeatures,
    v2ControllerTranscriptToScopeNotes,
    v2ControllerGetConversation,
    v2ControllerGetReeseRnResumeContext,
    v2ControllerGetSystemPrompt,
    v2ControllerLogout,
    v2EstimatesControllerGetEstimates,
    v2EstimatesControllerGetEstimate,
    v2EstimatesControllerUpdateEstimate,
    v2EstimatesControllerApplyTpaRules,
    v2EstimatesControllerCreateEstimate,
    v2EstimatesControllerUpdateScopeNotes,
    v2EstimatesControllerAddScopeNoteToEstimate,
    v2EstimatesControllerValidatePdfExport,
    v2EstimatesControllerGetZipTaxRate,
    v2EstimatesControllerExportToPdf,
    v2EstimatesControllerGetPdfPreviewData,
    v2EstimatesControllerArchive,
    intakeNoteControllerGetIntakeNotes,
    intakeNoteControllerCreateIntakeNote,
    intakeNoteControllerGetIntakeNote,
    intakeNoteControllerUpdateIntakeNote,
    intakeNoteControllerDeleteIntakeNote,
    intakeNoteControllerSubmitIntakeNote,
    intakeNoteControllerCompileSubsequentIntakeNote,
    intakeNoteControllerGetIntakeNoteResponse,
    intakeNoteControllerCreateIntakeNoteModuleResponse,
    roomControllerGetRooms,
    roomControllerCreateRoom,
    roomControllerGetRoom,
    roomControllerUpdateRoom,
    roomControllerDeleteRoom,
    roomControllerDuplicateRoom,
    roomControllerCompleteRoom,
    moduleResponseControllerGetModuleResponses,
    moduleResponseControllerCreateModuleResponse,
    moduleResponseControllerGetModuleResponse,
    moduleResponseControllerUpdateModuleResponse,
    moduleResponseControllerDeleteModuleResponse,
    moduleResponseControllerBulkSkipModuleResponses,
    moduleResponseControllerCreateFollowUpResponse,
    moduleResponseControllerUploadModuleResponseAudio,
    responsiveNoteControllerGetResponsiveNotes,
    responsiveNoteControllerCreateResponsiveNote,
    responsiveNoteControllerCreatePhotoPresignedUrl,
    responsiveNoteControllerCompletePhotoUpload,
    responsiveNoteControllerGetResponsiveNote,
    responsiveNoteControllerUpdateResponsiveNote,
    responsiveNoteControllerSubmitResponsiveNote,
    responsiveNoteControllerGetPhotos,
    responsiveNoteControllerCreatePhoto,
    responsiveNoteControllerDeletePhoto,
    responsiveNoteControllerProcessVoiceTranscript,
    responsiveNoteControllerGetVoiceTranscripts,
    responsiveNoteControllerGetVoiceTranscript,
    responsiveNoteControllerGetFollowUpQuestionCounts,
    responsiveNoteControllerGetFollowUpQuestions,
    responsiveNoteControllerAnswerFollowUpQuestion,
    responsiveNoteControllerDismissFollowUpQuestion,
    responsiveNoteControllerArchiveResponsiveNote,
    blockControllerGetBlocks,
    blockControllerUpsertBlock,
    blockControllerBatchBlocks,
    blockControllerUpdateBlock,
    blockControllerArchiveBlock,
    spaceControllerCreateSpace,
    spaceControllerGetSpaces,
    spaceControllerGetSpace,
    spaceControllerUpdateSpace,
    spaceControllerArchiveSpace,
    lineItemControllerSearchLineItems,
    lineItemControllerAddLineItem,
    lineItemControllerUpdateLineItem,
    lineItemControllerGetLineItemVariables,
    lineItemControllerConfirmLineItem,
    lineItemControllerArchiveLineItem,
    xactimateMappingControllerGetXactimateMappingsForEstimate,
    xactimateMappingControllerGetMappingByTemplateId,
    xactimateExportControllerValidate,
    xactimateExportControllerExport,
    xactimateExportControllerStartPhotoUpload,
    estimateRoomControllerCreateRoom,
    estimateRoomControllerUpdateRoom,
    estimateRoomControllerArchiveRoom,
    spaceScanControllerListScans,
    spaceScanControllerGetScan,
    spaceScanControllerUpsertScan,
    spaceScanControllerUpdateScan,
    spaceScanControllerDeleteScan,
    spaceScanControllerGetSketch,
    photoReportControllerExport,
    photoReportControllerLetterhead,
    photoReportControllerPhotos,
    moduleTemplateControllerGetModules,
    moduleTemplateControllerCreateModule,
    moduleTemplateControllerGetBulkModulesForIntake,
    moduleTemplateControllerGetModulesForIntake,
    moduleTemplateControllerUpdateModule,
    moduleTemplateControllerDeleteModule,
    responsiveNoteTemplateControllerGetTemplates,
    responsiveNoteTemplateControllerGetBulkTemplatesForPrefetch,
    responsiveNoteTemplateControllerGetTemplate,
    appVersionControllerCheckVersion,
    appWarningsControllerCheckWarnings,
    voiceControllerCreateSession,
    voiceControllerTranscribeRecording,
    jobControllerGetJob,
    jobControllerGetJobsForEstimate,
    userPreferencesControllerGetUserPreferences,
    userPreferencesControllerUpdateUserPreferences,
    rateCardV2ControllerListRateCards,
    rateCardV2ControllerGetRateCard,
    tpaV2ControllerList,
    tpaV2ControllerGetById,
    carrierV2ControllerList,
    carrierV2ControllerGetById,
    failedOfflineSyncMutationControllerCreateFailedMutations,
    failedOfflineSyncMutationControllerGetFailedCascades,
    failedOfflineSyncMutationControllerUpdateFailedMutationStatus,
    failedOfflineSyncMutationControllerGetCascadeMutations,
    toolsControllerGetOrganizations,
    internalXactimateMappingsControllerGetXactimateMappings,
    internalXactimateMappingsControllerBatchSetXactimateMappings,
    internalXactimateMappingsControllerSetXactimateMapping,
    internalXactimateMappingsControllerDeleteXactimateMapping,
    sourceTextsToSkipControllerListSourceTextsToSkip,
    sourceTextsToSkipControllerCreateSourceTextToSkip,
    sourceTextsToSkipControllerUpdateSourceTextToSkip,
    sourceTextsToSkipControllerDeleteSourceTextToSkip,
    managedResponsiveNoteTemplateControllerGetTemplates,
    managedResponsiveNoteTemplateControllerCreateTemplate,
    managedResponsiveNoteTemplateControllerGetTemplate,
    managedResponsiveNoteTemplateControllerUpdateTemplate,
    managedResponsiveNoteTemplateControllerArchiveTemplate,
    managedRateCardControllerListRateCards,
    managedRateCardControllerCreateRateCard,
    managedRateCardControllerGetRateCard,
    managedRateCardControllerUpdateRateCard,
    managedRateCardControllerDeleteRateCard,
    managedRateCardControllerCreateRateItem,
    managedRateCardControllerBulkCreateRateItems,
    managedRateCardControllerUpdateRateItem,
    managedRateCardControllerDeleteRateItem,
    managedRateCardControllerExtractRateItems,
    customContextControllerListCustomContexts,
    customContextControllerCreateCustomContext,
    customContextControllerUpdateCustomContext,
    customContextControllerDeleteCustomContext,
    rulesControllerGetRules,
    rulesControllerCreateRule,
    rulesControllerGetRuleById,
    rulesControllerUpdateRule,
    lineItemTemplateControllerSearchLineItemPermutations,
    manualEstimateReviewControllerListManualEstimateReviewTrackers,
    manualEstimateReviewControllerCreateManualEstimateReview,
    manualEstimateReviewControllerUpdateManualEstimateReviewTracker,
    agentConversationControllerStartSession,
    agentConversationControllerGetSessionStatus,
    organizationsControllerGetNames,
    organizationsControllerGetSystemPrompt,
    tpaControllerList,
    tpaControllerGetById,
    carrierControllerList,
    carrierControllerGetById,
    feedbackControllerCreateLineItemFeedback,
    webRateCardControllerListRateCards,
    webRateCardControllerGetRateCard,
    appScriptControllerHandleGoogleFormsSubmission,
    healthControllerHealthCheck,
    jobNimbusControllerHandleEstimate,
    firstAtlanticControllerHandleEstimate,
    psaControllerTriggerPoll,
    deployControllerGetState,
    deployControllerGetDiff,
    deployControllerPromote,
    deployControllerAuthenticate,
    deployControllerReceiveEvents,
    jobControllerGetJobByJobId,
    jobControllerGetJobsForEstimateByEstimateId
  };
};
export {
  getRebuildAPI
};
//# sourceMappingURL=index.mjs.map